import RsaRiepilogoPresenze from "../index.js";

const routes = [
    {
        name: "Rsa",
        path: "/rsariepilogopresenze",
        component: RsaRiepilogoPresenze.RsaRiepilogoPresenzePage,
        meta: { title: "Riepilogo Presenze" },
    },
];

export default routes;
